import React from 'react';

import cn from 'classnames';

import Avatar from 'components/Avatar';
import { MessageContent } from 'components/ComponentV2';

import styles from './ChatBubble.module.scss';

interface ChatBubbleProps {
  isReceived: boolean;
  message: string;
  senderIcon?: string;
  senderName?: string;
  messageType?: string | null;
}

export const ChatBubble: React.FC<ChatBubbleProps> = (
  props: ChatBubbleProps
) => {
  const { isReceived, message, senderIcon, senderName, messageType } = props;

  return (
    <div
      className={cn(styles.chatBubbleWrapper, {
        [styles.chatBubbleRightAlign]: isReceived,
      })}
    >
      {messageType == 'Touchpoint' && !isReceived ? (
        <Avatar
          size="small"
          icon={senderIcon}
          name={senderName || ''}
          className={cn(styles.avatar, {
            [styles.avatarRightAlign]: isReceived,
          })}
        />
      ) : null}
      <div
        className={cn(styles.chatBubble, {
          [styles.chatBubbleReceived]: isReceived,
        })}
      >
        <MessageContent
          content={message}
          hasDarkBackground={isReceived}
          linkUnderlined={true}
        ></MessageContent>
      </div>
    </div>
  );
};
